import { render, staticRenderFns } from "./scoreContestantRoundDetailManage.vue?vue&type=template&id=60784e0e&scoped=true&"
import script from "./scoreContestantRoundDetailManage.vue?vue&type=script&lang=ts&"
export * from "./scoreContestantRoundDetailManage.vue?vue&type=script&lang=ts&"
import style0 from "./scoreContestantRoundDetailManage.vue?vue&type=style&index=0&id=60784e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60784e0e",
  null
  
)

export default component.exports